import {
  ArrowRight,
  BookmarkSimple,
  ClockClockwise,
  ClockCounterClockwise,
  Envelope,
  Headphones,
  Moon,
  Pause,
  Play,
  PlayCircle,
  SkipForward,
  SpeakerHigh,
  SpeakerSlash,
  Sparkle,
  Sun,
  X,
} from '@phosphor-icons/react';

export const ICON_MAP = {
  'arrow-right': ArrowRight,
  'bookmark-simple': BookmarkSimple,
  'clock-clockwise': ClockClockwise,
  'clock-counter-clockwise': ClockCounterClockwise,
  envelope: Envelope,
  headphones: Headphones,
  moon: Moon,
  pause: Pause,
  play: Play,
  'play-circle': PlayCircle,
  'skip-forward': SkipForward,
  'speaker-high': SpeakerHigh,
  'speaker-slash': SpeakerSlash,
  sparkle: Sparkle,
  sun: Sun,
  x: X,
};

export type IconName = keyof typeof ICON_MAP;

export type IconWeight = 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
